export default __webpack_public_path__ + "static/media/gi.b40b1c03.svg";